import { render, staticRenderFns } from "./EmailsParaNotificar.vue?vue&type=template&id=5c1c7ef6&"
import script from "./EmailsParaNotificar.vue?vue&type=script&lang=js&"
export * from "./EmailsParaNotificar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports